import ContentLoader from "react-content-loader";
import { HideMobile } from "../../../../02-atoms/06-layout/02-visibility/02-hide-mobile";
import { HideDesktop } from "../../../../02-atoms/06-layout/02-visibility/01-hide-desktop";

/**
 * Responsive placeholder skeleton for job teaser when page is loading.
 * Provides responsive layout for both mobile and desktop views.
 */
export const JobTeaserPlaceholder = () => {
  const renderDesktopLoader = () => (
    <ContentLoader
      height={60}
      width="100%"
      speed={2}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      uniqueKey="job-teaser-desktop"
      style={{ maxWidth: "400px", margin: "0 auto" }}
    >
      <rect x="20%" y="3" rx="3" ry="3" width="15%" height="7" />
      <rect x="40%" y="4" rx="3" ry="3" width="22%" height="7" />
      <rect x="65%" y="4" rx="3" ry="3" width="5%" height="7" />
      <rect x="25%" y="17" rx="3" ry="3" width="40%" height="7" />
      <rect x="60%" y="18" rx="3" ry="3" width="60%" height="7" />
      <rect x="25%" y="32" rx="3" ry="3" width="20%" height="7" />
      <rect x="50%" y="33" rx="3" ry="3" width="15%" height="7" />
      <rect x="70%" y="33" rx="3" ry="3" width="15%" height="7" />
      <rect x="20%" y="48" rx="3" ry="3" width="90%" height="7" />
      <rect x="0%" y="0" rx="0" ry="0" width="15%" height="59" />
    </ContentLoader>
  );

  const renderMobileLoader = () => (
    <ContentLoader
      height={80}
      width="100%"
      speed={2}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      uniqueKey="job-teaser-mobile"
      style={{ maxWidth: "300px", margin: "0 auto" }}
    >
      <rect x="0%" y="0" rx="0" ry="0" width="20%" height="59" />
      <rect x="25%" y="3" rx="3" ry="3" width="50%" height="7" />
      <rect x="25%" y="17" rx="3" ry="3" width="70%" height="7" />
      <rect x="25%" y="32" rx="3" ry="3" width="50%" height="7" />
      <rect x="25%" y="48" rx="3" ry="3" width="30%" height="7" />
    </ContentLoader>
  );

  return (
    <>
      <HideMobile>{renderDesktopLoader()}</HideMobile>
      <HideDesktop>{renderMobileLoader()}</HideDesktop>
    </>
  );
};
